import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=b72fa9ee"
import script from "./Reports.vue?vue&type=script&setup=true&lang=js"
export * from "./Reports.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports